import { Link } from 'react-router-dom';
import { categories } from '@/mocks/nodes';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: number;
  tags?: string[];
}

export default function ArticleCard({ slug, title, excerpt, category, date, readTime, tags }: ArticleCardProps) {
  const catInfo = categories.find((c) => c.slug === category);

  return (
    <article className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block p-5">
        <div className="flex items-center gap-2 mb-3">
          {catInfo && (
            <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-800">
              <i className={`${catInfo.icon} text-[10px]`}></i>
              {catInfo.name}
            </span>
          )}
          <span className="text-xs text-foreground-400">{date}</span>
          <span className="text-xs text-foreground-400">· {readTime} 分钟阅读</span>
        </div>
        <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        {tags && tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="px-2 py-0.5 text-xs bg-background-100 text-foreground-500 rounded-md">
                {tag}
              </span>
            ))}
          </div>
        )}
      </Link>
    </article>
  );
}